export interface DevLogin {
  email: string;
  password: string;
}

// Seed credentials for local verification, read from CLAUDE_USERNAME and CLAUDE_PASSWORD in .env.
// `yarn start` passes them to the dev server as REACT_APP_* vars; production builds never set them,
// and the NODE_ENV check lets the minifier drop this lookup from the bundle entirely.
export const getDevLogin = (): DevLogin | null => {
  if (process.env.NODE_ENV !== 'development') return null;

  const email = process.env.REACT_APP_CLAUDE_USERNAME;
  const password = process.env.REACT_APP_CLAUDE_PASSWORD;
  if (!email || !password) return null;

  return { email, password };
};
